<template>
  <div>
    <MemoryGame />
  </div>
</template>

<script>
import MemoryGame from "../components/MemoryGame.component";

export default {
  name: "Memory.container",
  components: {
    MemoryGame
  }
}
</script>

<style scoped>

</style>